import { BB_ATTRIBUTES_MODE } from '/bb/constants.js';

let attributesMode = BB_ATTRIBUTES_MODE.MERGE;

export function getAttributesMode() {
  return attributesMode;
}

export function setAttributesMode(mode) {
  attributesMode = normalizeAttributesMode(mode) || BB_ATTRIBUTES_MODE.MERGE;
}

export function normalizeAttributesMode(rawMode) {
  if (!rawMode) return BB_ATTRIBUTES_MODE.MERGE;

  const mode = String(rawMode).trim().toLowerCase();
  if (mode === BB_ATTRIBUTES_MODE.MERGE || mode === BB_ATTRIBUTES_MODE.REPLACE) return mode;

  return null;
}
